import { extendTheme } from "@chakra-ui/react";
import { colors } from "./colors";
import { Button } from "./button";

export const theme = extendTheme({
  colors,
  components: {
    Button,
  },
  fonts: {
    heading: `"HelveticaNeue", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    body: `"HelveticaNeue", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
  },
  fontWeights: {
    // HACK FOR CONSISTENT WEIGHT
    normal: 400,
    medium: 400,
    bold: 400,
  },
  textStyles: {
    h1: {},
    h2: {},
    h3: {},
  },
  // layerStyles: {
  //   base: {
  //     bg: "gray.50",
  //     border: "2px solid",
  //     borderColor: "gray.500",
  //   },
  //   bold: {
  //     fontFamily: "Whyte Rounded Inktrap Medium",
  //   },
  // },
  styles: {
    global: (props: any) => ({
      html: {
        margin: 0,
        padding: 0,
        fontWeight: "normal",
        fontSize: {
          // base: "calc(10px + (18 - 10) * (100vw - 320px) / (480 - 320))",
          // md: "calc(14px + (30 - 14) * (100vw - 482px) / (1920 - 482))",
          // xl: "1.48889vw",
        },
        h1: {
          letterSpacing: "-1px",
          textTransform: "uppercase",
        },
        h2: {
          letterSpacing: "-1px",
        },
        h3: {
          letterSpacing: "-1px",
        },
      },
      body: {
        background: "#fafafa",
        minHeight: "100vh",
      },
      a: {
        _hover: {
          textDecoration: "none !important",
        },
      },
    }),
  },
});

export default theme;
